<template>
  <b-modal id="modalRadiusAttrDynamicShaping" ref="modalRadiusAttrDynamicShaping" :title="$t('RADIUS parameters')" hide-footer size="lg">
    <div>
      <b-form-group label-align="right" :label="$t('Vendor')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="editRadiusAttr.rad_vendor" aria-describedby="inputFeedbackVendor" :state="editRadiusAttr.rad_vendor > 0"/>
          <b-form-invalid-feedback id="inputFeedbackVendor">
            {{ $t('Enter number') }}
          </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Attribute')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="editRadiusAttr.rad_attr" aria-describedby="inputFeedbackAttribute" :state="editRadiusAttr.rad_attr > 0"/>
          <b-form-invalid-feedback id="inputFeedbackAttribute">
            {{ $t('Enter number') }}
          </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-input-group>
          <b-form-select v-model="valOptions" :options="options"/>
          <b-input-group-append>
            <b-button @click="addOptions">{{ $t('Add') }}</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Value')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="editRadiusAttr.value" aria-describedby="inputFeedbackValue" :state="editRadiusAttr.value.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackValue">
            {{ $t('Enter value') }}
          </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-radio-group v-model="editRadiusAttr.rad_type" name="radioType">
          <b-form-radio :value=1>{{ $t('String') }}</b-form-radio>
          <b-form-radio :value=2>{{ $t('Number') }}</b-form-radio>
          <b-form-radio :value=3>{{ $t('Binary') }}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>

      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalRadiusAttrDynamicShaping.hide">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    editRadiusAttr: null,
    radiusAttrItems: null
  },
  data () {
    return {
      valOptions: 'IN_BANDWIDTH_BITS',
      options: [
        {value: 'IN_BANDWIDTH_BITS', text: this.$i18n.t('Incoming bandwidth limit (bit/s)')},
        {value: 'IN_BANDWIDTH_KBITS', text: this.$i18n.t('Incoming bandwidth limit (Kbit/s)')},
        {value: 'IN_BANDWIDTH_MBITS', text: this.$i18n.t('Incoming bandwidth limit (Mbit/s)')},
        {value: 'OUT_BANDWIDTH_BITS', text: this.$i18n.t('Outgoing bandwidth limit (bit/s)')},
        {value: 'OUT_BANDWIDTH_KBITS', text: this.$i18n.t('Outgoing bandwidth limit (Kbit/s)')},
        {value: 'OUT_BANDWIDTH_MBITS', text: this.$i18n.t('Outgoing bandwidth limit (Mbit/s)')},
        {value: 'IN_CISCO_NORMAL_BURST', text: this.$i18n.t('Cisco normal burst (in)')},
        {value: 'OUT_CISCO_NORMAL_BURST', text: this.$i18n.t('Cisco normal burst (out)')},
        {value: 'IN_CISCO_EXTENDED_BURST', text: this.$i18n.t('Cisco extended burst (in)')},
        {value: 'OUT_CISCO_EXTENDED_BURST', text: this.$i18n.t('Cisco extended burst (out)')},
        {value: 'IN_RAW_TEXT', text: this.$i18n.t('Raw text (in)')},
        {value: 'OUT_RAW_TEXT', text: this.$i18n.t('Raw text (out)')}
      ]
    }
  },
  methods: {
    save () {
      if (this.editRadiusAttr.rad_vendor <= 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Vendor fields is invalid'), 'Error')
        return
      }
      if (this.editRadiusAttr.rad_attr <= 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attribute fields is invalid'), 'Error')
        return
      }
      if (!this.editRadiusAttr.value) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Value fields is invalid'), 'Error')
        return
      }

      this.editRadiusAttr.rad_attr = Number(this.editRadiusAttr.rad_attr)
      this.editRadiusAttr.rad_vendor = Number(this.editRadiusAttr.rad_vendor)
      switch (this.editRadiusAttr.rad_type) {
        case 1:
          this.$set(this.editRadiusAttr, 'type', this.$i18n.t('String'))
          break
        case 2:
          this.$set(this.editRadiusAttr, 'type', this.$i18n.t('Number'))
          break
        case 3:
          this.$set(this.editRadiusAttr, 'type', this.$i18n.t('Binary'))
          break
      }
      if (!this.editRadiusAttr.isEdit) {
        this.radiusAttrItems.push(this.editRadiusAttr)
      }
      this.$refs.modalRadiusAttrDynamicShaping.hide()
    },
    addOptions () {
      this.editRadiusAttr.value += this.valOptions
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/system/dynamicShaping/radiusAttr.vue